import {trackEvent, TrackEventData} from '@hconnect/common/logging/Analytics'
import {useRequiredUser} from '@hconnect/login'
import {Page} from '@widgets/shift-event-filters'
import {isObject} from 'lodash'
import {useCallback} from 'react'

type PerformanceAnalyticsEvent = {
  name: 'userAdjustsFilter'
  data: {filterPage: Page; filterName?: string}
}

interface CommonAnalyticsData {
  data: {
    plantId?: string
    userId?: string
  }
}

type AnalyticsEvent = PerformanceAnalyticsEvent & CommonAnalyticsData

const trackAnalyticsEvent = <T extends AnalyticsEvent['name']>(
  eventName: T,
  data: TrackEventData
) => trackEvent(eventName, {product: 'cockpit', ...data})

type Params = {
  plantId: string
  country: string
}

export const useTrackPerformanceAnalytics = ({plantId, country}: Params) => {
  const {id: userId} = useRequiredUser()

  return useCallback(
    <T extends AnalyticsEvent['name']>(
      eventName: T,
      data: Extract<AnalyticsEvent, {name: T}> extends {data: infer D} ? D : Record<string, never>
    ) => {
      if (plantId) {
        trackAnalyticsEvent(eventName, {
          timestamp: new Date().toISOString(),
          userId,
          plantId,
          country,
          ...(isObject(data) ? data : {})
        })
      }
    },
    [plantId, userId, country]
  )
}
